import {
  BaseFormElement,
  DatePickerElement,
  ExternalElement,
  FormElement,
  InputElement,
  InputSearchDropdownElement,
  PhoneInputElement,
  RadioGroupElement,
  SelectElement,
  TextAreaElement,
  Validations
} from './types';

export const isExternalElement = (element: FormElement): element is ExternalElement => {
  return element.tag === 'external';
};

export const isInput = (element: FormElement): element is InputElement => {
  return element.tag === 'input';
};

export const isLabel = (element: FormElement): element is BaseFormElement => {
  return element.tag === 'label';
};

export const isRadioGroup = (element: FormElement): element is RadioGroupElement => {
  return element.tag === 'radioGroup';
};

export const isDateInput = (element: FormElement): element is InputElement => {
  return element.tag === 'dateInput';
};

export const isSelect = (element: FormElement): element is SelectElement => {
  return element.tag === 'select';
};

export const isDatePicker = (element: FormElement): element is DatePickerElement => {
  return element.tag === 'datePicker';
};

export const isTextarea = (element: FormElement): element is TextAreaElement => {
  return element.tag === 'textarea';
};

export const isInputSearchDropdown = (
  element: FormElement
): element is InputSearchDropdownElement => {
  return element.tag === 'inputSearchDropdown';
};

export const isValidations = (
  item: Validations | Record<string, Validations>
): item is Validations => {
  return !!item.schema;
};

export const isPhoneInput = (element: FormElement): element is PhoneInputElement =>
  element.tag === 'phoneInput';
